import React, { useState } from "react";
import RenderTranslatedText from "../../components/RenderTranslatedText";
import { CustomInput } from "../../components/CustomInput";
import { useTranslation } from "react-i18next";
import ImageUpload from "../../components/ImageUpload";
import OtaGradientButton from "../../components/OtaGradientButton";
import Select from "react-select";
import { characterCategoriesConfig } from "../characters/constants";
import { backButton } from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import useResetScroll from "../../utils/useResetScroll";

export default function CommunityCreate() {
  useResetScroll();
  const navigate = useNavigate();
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const options = characterCategoriesConfig.map(({ labelKey, icon, value }) => {
    return {
      label: t(labelKey),
      value,
      icon,
    };
  });

  const [name, setName] = useState();
  const [image, setImage] = useState();
  const [category, setCategory] = useState();
  const [isCreating, setIsCreating] = useState(false);

  const handleCreate = async () => {
    if (isCreating || !name || !image || !category) return;
    setIsCreating(true);
    try {
      const response = await fetch(
        `https://api.be-native.life/api/travel/favcard`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: name,
            imageId: image,
            tag: category?.value,
            param1: localStorage.getItem("USER_ID"),
            param2: "",
            param3: "",
            param4: "",
          }),
        }
      );
      const data = await response.json();
      navigate(`/community/${data?.favcard_id}`);
    } catch (_) {
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="otaPageBg w-full min-h-[100svh] relative">
      <div className="max-w-[450px] mx-auto relative">
        <div className="w-full min-h-[100svh]">
          <div className="p-5 w-full h-[60px] bg-white flex items-center">
            <div className="max-w-[450px] mx-auto w-full">
              <div className="flex items-center gap-2">
                <div onClick={() => navigate(-1)}>
                  <img className="w-[24px]" src={backButton} />
                </div>
                <p className="font-semibold text-[17px] text-[#414853]">
                  <RenderTranslatedText
                    i8nKey={"community_page_create_new_community_cta"}
                  />
                </p>
              </div>
            </div>
          </div>
          <div className="p-5 max-w-[450px] mx-auto">
            <div className="w-[95%] mx-auto flex flex-col gap-5">
              <CustomInput
                label={t("community_create_page_input_title")}
                onChange={(value) => setName(value)}
                value={name}
                placeholder={t("community_create_page_placeholder_title")}
                type="text"
              />

              <div>
                <p className="text-[14px] otaLight font-normal pb-2">
                  <RenderTranslatedText
                    i8nKey={"community_create_page_category_input_title"}
                  />
                </p>
                <Select
                  placeholder={t(
                    "community_create_page_category_input_placeholder"
                  )}
                  options={options}
                  isSearchable={false}
                  formatOptionLabel={(country) => (
                    <div className="flex items-center gap-3">
                      <img className="w-[30px]" src={country.icon} />
                      <span>{country.label}</span>
                    </div>
                  )}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      border: "1px solid #D0D5DD",
                      padding: "6px 4px",
                      borderRadius: "12px",
                    }),
                  }}
                  onChange={(value) => setCategory(value)}
                  value={category}
                />
              </div>
              <ImageUpload
                label={t("community_create_page_image_input_title")}
                onUpload={(image) => setImage(image)}
              />
            </div>
            <OtaGradientButton
              onClick={handleCreate}
              className="rounded-[10px] bg-[#333] w-[100%] h-[48px] px-[16px] py-[12px] text-white mt-10"
            >
              <RenderTranslatedText
                i8nKey={"community_create_page_button_cta"}
              />
            </OtaGradientButton>
          </div>
        </div>
      </div>
    </div>
  );
}
